



import { defineComponent, onMounted, ref } from '@vue/composition-api';

export default defineComponent({
	props: {
		placeholder: {
			type: String,
		},
	},
	setup() {
		const tableFilter = ref();
		let initialTable: HTMLTableElement | null | undefined;
		let table: HTMLTableElement | null | undefined;
		let tableWidth: number;
		function onInput() {
			if (!table || !initialTable) {
				return;
			}
			const inputValue = (tableFilter.value as HTMLInputElement).value.toLowerCase();
			const results: Element[] = [];
			// look through all table rows
			initialTable.querySelectorAll('tr').forEach((row) => {
				row.querySelectorAll('*').forEach((item) => {
					const itemContent = item.innerHTML.toLowerCase();
					if (itemContent.includes(inputValue) && !results.includes(row)) {
						// exception for 'kaufen' so lines containing 'verkaufen' aren't shown
						if (
							inputValue !== 'kaufen' ||
							(!itemContent.includes('verkaufen') && inputValue === 'kaufen')
						) {
							results.push(row);
						}
					}
				});
			});
			const tableHead = initialTable.querySelector('tr') as HTMLElement;
			if (!results.includes(tableHead)) {
				results.unshift(tableHead);
			}
			let resultsHTML = '';
			results.forEach((result) => {
				resultsHTML += result.outerHTML;
			});
			table.innerHTML = resultsHTML;
			table.style.width = `${tableWidth}px`;
		}
		onMounted(() => {
			table = (tableFilter.value as HTMLInputElement).parentElement?.querySelector('table');
			if (table && !initialTable) {
				initialTable = table.cloneNode(true) as HTMLTableElement;
				tableWidth = table.clientWidth;
				(tableFilter.value as HTMLInputElement).style.width = `${table.clientWidth}px`;
			}
		});
		return { onInput, tableFilter };
	},
});
